module.exports = __webpack_public_path__ + "static/media/growbag_shop4.52fedc2d.webp";